import React, { useState } from 'react';
import { LanguagesIcon, MonitorIcon, LayoutDashboardIcon, TableIcon, HelpCircleIcon, EyeIcon, PaletteIcon, TextIcon, GridIcon, SunIcon, MoonIcon, ColumnsIcon, MessageSquareIcon, AccessibilityIcon, GlobeIcon, CalendarIcon, CircleDotIcon } from 'lucide-react';
export const UIUXSettings = () => {
  // Example state for live previews
  const [selectedTheme, setSelectedTheme] = useState('light');
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [selectedLocale, setSelectedLocale] = useState('en-US');
  const [highContrastMode, setHighContrastMode] = useState(false);
  return <div className="space-y-8" data-id="element-1636">
      {/* Localization & Formatting */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1637">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1638">
          Localization & Formatting
        </h3>
        <div className="space-y-6" data-id="element-1639">
          {/* Language Settings */}
          <div data-id="element-1640">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1641">
              Language Configuration
            </label>
            <div className="space-y-4" data-id="element-1642">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1643">
                <div className="border border-gray-200 rounded-lg p-4" data-id="element-1644">
                  <div className="flex items-center justify-between mb-3" data-id="element-1645">
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1646">
                      Default System Language
                    </h4>
                    <LanguagesIcon className="h-5 w-5 text-gray-400" data-id="element-1647" />
                  </div>
                  <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={selectedLanguage} onChange={e => setSelectedLanguage(e.target.value)} data-id="element-1648">
                    <option value="am" data-id="element-1649">Amharic (አማርኛ)</option>
                    <option value="en" data-id="element-1650">English</option>
                    <option value="or" data-id="element-1651">Oromo (Afaan Oromoo)</option>
                    <option value="ti" data-id="element-1652">Tigrinya (ትግርኛ)</option>
                  </select>
                </div>
                <div className="border border-gray-200 rounded-lg p-4" data-id="element-1653">
                  <div className="flex items-center justify-between mb-3" data-id="element-1654">
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1655">
                      Supported Languages
                    </h4>
                    <GlobeIcon className="h-5 w-5 text-gray-400" data-id="element-1656" />
                  </div>
                  <div className="space-y-2" data-id="element-1657">
                    {['Amharic', 'English', 'Oromo', 'Tigrinya'].map(lang => <div key={lang} className="flex items-center" data-id="element-1658">
                        <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-1659" />
                        <label className="ml-2 text-sm text-gray-700" data-id="element-1660">
                          {lang}
                        </label>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Locale Settings */}
          <div data-id="element-1661">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1662">
              Locale & Formatting
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1663">
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1664">
                <div className="flex items-center justify-between mb-3" data-id="element-1665">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1666">
                    Date & Time Format
                  </h4>
                  <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-1667" />
                </div>
                <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={selectedLocale} onChange={e => setSelectedLocale(e.target.value)} data-id="element-1668">
                  <option value="en-US" data-id="element-1669">MM/DD/YYYY</option>
                  <option value="en-GB" data-id="element-1670">DD/MM/YYYY</option>
                  <option value="et-ET" data-id="element-1671">
                    Ethiopian Calendar (የኢትዮጵያ ቀን አቆጣጠር)
                  </option>
                </select>
                <div className="mt-2 text-sm text-gray-500" data-id="element-1672">
                  Preview: {new Date().toLocaleDateString(selectedLocale)}
                </div>
              </div>
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1673">
                <div className="flex items-center justify-between mb-3" data-id="element-1674">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1675">
                    Number Format
                  </h4>
                  <TextIcon className="h-5 w-5 text-gray-400" data-id="element-1676" />
                </div>
                <div className="space-y-2" data-id="element-1677">
                  <div className="flex items-center justify-between text-sm" data-id="element-1678">
                    <span className="text-gray-600" data-id="element-1679">Decimal Separator</span>
                    <select className="border-gray-300 rounded-md text-sm" data-id="element-1680">
                      <option data-id="element-1681">.</option>
                      <option data-id="element-1682">,</option>
                    </select>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-1683">
                    <span className="text-gray-600" data-id="element-1684">Thousands Separator</span>
                    <select className="border-gray-300 rounded-md text-sm" data-id="element-1685">
                      <option data-id="element-1686">,</option>
                      <option data-id="element-1687">.</option>
                      <option data-id="element-1688">Space</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Theme & Visual Preferences */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1689">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1690">
          Theme & Visual Preferences
        </h3>
        <div className="space-y-6" data-id="element-1691">
          {/* Theme Selection */}
          <div data-id="element-1692">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1693">
              System Theme
            </label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1694">
              {[{
              id: 'light',
              name: 'Light Theme',
              icon: SunIcon
            }, {
              id: 'dark',
              name: 'Dark Theme',
              icon: MoonIcon
            }, {
              id: 'system',
              name: 'System Default',
              icon: MonitorIcon
            }].map(theme => <div key={theme.id} className={`border rounded-lg p-4 cursor-pointer ${selectedTheme === theme.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setSelectedTheme(theme.id)} data-id="element-1695">
                  <div className="flex items-center space-x-3" data-id="element-1696">
                    <theme.icon className={`h-5 w-5 ${selectedTheme === theme.id ? 'text-blue-500' : 'text-gray-400'}`} data-id="element-1697" />
                    <span className={`text-sm ${selectedTheme === theme.id ? 'text-blue-700 font-medium' : 'text-gray-900'}`} data-id="element-1698">
                      {theme.name}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Color Scheme */}
          <div data-id="element-1699">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1700">
              Color Scheme
            </label>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1701">
              {[{
              name: 'Default Blue',
              color: 'bg-blue-500'
            }, {
              name: 'Forest Green',
              color: 'bg-green-500'
            }, {
              name: 'Royal Purple',
              color: 'bg-purple-500'
            }, {
              name: 'Sunset Orange',
              color: 'bg-orange-500'
            }].map(scheme => <div key={scheme.name} className="border border-gray-200 rounded-lg p-4" data-id="element-1702">
                  <div className={`h-6 w-full rounded ${scheme.color} mb-2`} data-id="element-1703"></div>
                  <span className="text-sm text-gray-900" data-id="element-1704">{scheme.name}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {/* Dashboard & Layout Customization */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1705">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1706">
          Dashboard & Layout Customization
        </h3>
        <div className="space-y-6" data-id="element-1707">
          {/* Dashboard Widgets */}
          <div data-id="element-1708">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1709">
              Dashboard Widget Configuration
            </label>
            <div className="space-y-4" data-id="element-1710">
              {[{
              role: 'Administrator',
              widgets: ['System Overview', 'User Activity', 'Revenue Summary']
            }, {
              role: 'Finance Officer',
              widgets: ['Revenue Summary', 'Payment Analytics', 'Outstanding Bills']
            }, {
              role: 'Service Desk',
              widgets: ['Active Requests', 'Queue Status', 'Customer Feedback']
            }].map(config => <div key={config.role} className="border border-gray-200 rounded-lg p-4" data-id="element-1711">
                  <div className="flex items-center justify-between mb-3" data-id="element-1712">
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1713">
                      {config.role}
                    </h4>
                    <LayoutDashboardIcon className="h-5 w-5 text-gray-400" data-id="element-1714" />
                  </div>
                  <div className="space-y-2" data-id="element-1715">
                    {config.widgets.map(widget => <div key={widget} className="flex items-center justify-between text-sm" data-id="element-1716">
                        <span className="text-gray-600" data-id="element-1717">{widget}</span>
                        <div className="flex items-center space-x-2" data-id="element-1718">
                          <button className="text-gray-400 hover:text-gray-500" data-id="element-1719">
                            <GridIcon className="h-4 w-4" data-id="element-1720" />
                          </button>
                          <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" defaultChecked data-id="element-1721" />
                        </div>
                      </div>)}
                  </div>
                </div>)}
            </div>
          </div>
          {/* Table Preferences */}
          <div data-id="element-1722">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1723">
              Table Display Preferences
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1724">
              <div className="space-y-4" data-id="element-1725">
                <div data-id="element-1726">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1727">
                    Default Items Per Page
                  </h4>
                  <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-1728">
                    <option data-id="element-1729">10</option>
                    <option data-id="element-1730">25</option>
                    <option data-id="element-1731">50</option>
                    <option data-id="element-1732">100</option>
                  </select>
                </div>
                <div data-id="element-1733">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1734">
                    Default Sort Direction
                  </h4>
                  <div className="flex items-center space-x-4" data-id="element-1735">
                    <label className="inline-flex items-center" data-id="element-1736">
                      <input type="radio" name="sort" className="h-4 w-4 text-blue-600 border-gray-300" data-id="element-1737" />
                      <span className="ml-2 text-sm text-gray-700" data-id="element-1738">
                        Ascending
                      </span>
                    </label>
                    <label className="inline-flex items-center" data-id="element-1739">
                      <input type="radio" name="sort" className="h-4 w-4 text-blue-600 border-gray-300" defaultChecked data-id="element-1740" />
                      <span className="ml-2 text-sm text-gray-700" data-id="element-1741">
                        Descending
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Accessibility & Help Settings */}
      <div className="pt-8" data-id="element-1742">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1743">
          Accessibility & Help Settings
        </h3>
        <div className="space-y-6" data-id="element-1744">
          {/* Accessibility Options */}
          <div data-id="element-1745">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1746">
              Accessibility Settings
            </label>
            <div className="space-y-4" data-id="element-1747">
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1748">
                <div className="flex items-center justify-between mb-4" data-id="element-1749">
                  <div className="flex items-center" data-id="element-1750">
                    <AccessibilityIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-1751" />
                    <h4 className="text-sm font-medium text-gray-900" data-id="element-1752">
                      High Contrast Mode
                    </h4>
                  </div>
                  <div className="relative inline-block w-10 mr-2 align-middle select-none" data-id="element-1753">
                    <input type="checkbox" checked={highContrastMode} onChange={e => setHighContrastMode(e.target.checked)} className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-1754" />
                    <label className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" data-id="element-1755"></label>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1756">
                  <div className="flex items-center justify-between text-sm" data-id="element-1757">
                    <span className="text-gray-600" data-id="element-1758">Text Size</span>
                    <select className="border-gray-300 rounded-md" data-id="element-1759">
                      <option data-id="element-1760">Normal</option>
                      <option data-id="element-1761">Large</option>
                      <option data-id="element-1762">Extra Large</option>
                    </select>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-1763">
                    <span className="text-gray-600" data-id="element-1764">
                      Animation Reduced Motion
                    </span>
                    <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300" data-id="element-1765" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Help Text Management */}
          <div data-id="element-1766">
            <label className="block text-sm font-medium text-gray-700 mb-4" data-id="element-1767">
              Help Text & Tooltip Configuration
            </label>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1768">
              <div className="space-y-4" data-id="element-1769">
                <div className="flex items-center justify-between" data-id="element-1770">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1771">
                    Tooltip Display
                  </h4>
                  <select className="border-gray-300 rounded-md text-sm" data-id="element-1772">
                    <option data-id="element-1773">On Hover</option>
                    <option data-id="element-1774">On Click</option>
                    <option data-id="element-1775">Always Visible</option>
                  </select>
                </div>
                <div className="flex items-center justify-between" data-id="element-1776">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-1777">
                    Tooltip Position
                  </h4>
                  <select className="border-gray-300 rounded-md text-sm" data-id="element-1778">
                    <option data-id="element-1779">Top</option>
                    <option data-id="element-1780">Bottom</option>
                    <option data-id="element-1781">Left</option>
                    <option data-id="element-1782">Right</option>
                  </select>
                </div>
                <div data-id="element-1783">
                  <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1784">
                    Preview
                  </h4>
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-1785">
                    <div className="flex items-center justify-center space-x-4" data-id="element-1786">
                      <button className="relative group" data-id="element-1787">
                        <span className="text-sm text-gray-700" data-id="element-1788">Hover me</span>
                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded-md opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1789">
                          Example Tooltip
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};